import type { Rotina } from "~/types/pagesMenu";

const nomesRotinasConvocacaoAtiva = {
	AGUARDAR_CONVOCACAO: "Aguardar Convocação",
	COLAGEM_CRACHA: "Liberação do Palete para Armazenamento"
} as const;
export type RotinasConvocacaoAtiva = typeof nomesRotinasConvocacaoAtiva[keyof typeof nomesRotinasConvocacaoAtiva];


const rotinasConvocacaoAtiva: Rotina[] = [
	{
		categoria: "Convocação Ativa",
		label: nomesRotinasConvocacaoAtiva.AGUARDAR_CONVOCACAO,
		nome: "mni_ColetorDadosAguardarConvocacao",
		rotina: "PROC_CONV_ATIVA_COL_AGENTES",
		tela: "B331",
		/*
		 * Estava `false`, e era a única rotina assim entre as 17 — por isso a
		 * categoria "Convocação Ativa" nunca desenhava botão nenhum: o menu filtra
		 * por `visible`, que sai daqui (`definirRotinasDisponiveis` → `visiveis()`
		 * em `collectorOptions.vue`).
		 *
		 * A permissão `mni_ColetorDadosAguardarConvocacao` existe e está
		 * distribuída (31 usuários no AGALDINO), a tela
		 * `PROC_CONV_ATIVA_COL_AGENTES` está escrita e o módulo `ConvocacaoAtiva`
		 * tem os 6 contratos com os 6 casos de uso correspondentes.
		 */
		disponivel: true
	},
	{
		/*
		 * B332. O campo `tela` leva o NOME DO FORMULÁRIO, não o código: o código
		 * "B332" já está declarado literalmente por outra rotina do menu de
		 * Expedição, que na verdade é a 362. Quem traduz formulário -> código
		 * exibido é o `CODIGO_POR_FORMULARIO` de `iconesRotinas.ts`, e é assim
		 * que outras doze rotinas já funcionam desde a r187.
		 *
		 * O item de menu é o mesmo do Delphi
		 * (`mni_ColetorDadosLiberacaoPaleteArmazenamento`, caption "B332 -
		 * Liberação do Palete para Armazenamento"). Na base da dev ele existe
		 * para 27 usuários.
		 */
		categoria: "Convocação Ativa",
		label: nomesRotinasConvocacaoAtiva.COLAGEM_CRACHA,
		nome: "mni_ColetorDadosLiberacaoPaleteArmazenamento",
		rotina: "convocacaoAtiva/colagemCracha",
		tela: "PROC_CONV_ATIVA_COLAGEM_CRACHA",
		disponivel: true
	}
];

export { rotinasConvocacaoAtiva };
